import React from "react";

const Present = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.9375 6.1875H18.2488C18.657 5.61172 18.9062 4.90273 18.9062 4.125C18.9062 2.23008 17.4711 0.6875 15.7051 0.6875C13.8875 0.6875 12.8348 1.77891 11 4.80391C9.16523 1.77891 8.1125 0.6875 6.29492 0.6875C4.52891 0.6875 3.09375 2.23008 3.09375 4.125C3.09375 4.90273 3.34297 5.61172 3.75117 6.1875H2.0625C0.923828 6.1875 0 7.11133 0 8.25V12.375C0 12.7531 0.309375 13.0625 0.6875 13.0625H1.375V19.25C1.375 20.3887 2.29883 21.3125 3.4375 21.3125H18.5625C19.7012 21.3125 20.625 20.3887 20.625 19.25V13.0625H21.3125C21.6906 13.0625 22 12.7531 22 12.375V8.25C22 7.11133 21.0762 6.1875 19.9375 6.1875ZM11.868 6.03281C13.9949 2.45352 14.7039 2.0625 15.7051 2.0625C16.7105 2.0625 17.5312 2.98633 17.5312 4.125C17.5312 5.26367 16.7105 6.1875 15.7051 6.1875H11.7734L11.868 6.03281ZM6.29492 2.0625C7.30039 2.0625 8.00508 2.45352 10.132 6.03281L10.2223 6.1875H6.29062C5.28516 6.1875 4.46445 5.26367 4.46445 4.125C4.46875 2.98633 5.28945 2.0625 6.29492 2.0625ZM8.25 19.9375H3.4375C3.05937 19.9375 2.75 19.6281 2.75 19.25V13.0625H8.25V19.9375ZM8.25 11.6875H1.375V8.25C1.375 7.87187 1.68437 7.5625 2.0625 7.5625H8.25V11.6875ZM12.375 19.9375H9.625V7.5625H12.375V19.9375ZM19.25 19.25C19.25 19.6281 18.9406 19.9375 18.5625 19.9375H13.75V13.0625H19.25V19.25ZM20.625 11.6875H13.75V7.5625H19.9375C20.3156 7.5625 20.625 7.87187 20.625 8.25V11.6875Z"
        fill="white"
      />
    </svg>
  );
};

export default Present;
